export const state = {
  activeCall: null, // { callId, conversationId, callerName, status, startTime }
  isMuted: false,
  isConnected: false,
  duration: 0,
  janusSession: null,
  janusPluginHandle: null,
};

export const getters = {
  hasActiveCall: state => !!state.activeCall,
  activeCall: state => state.activeCall,
  isMuted: state => state.isMuted,
  isConnected: state => state.isConnected,
  callDuration: state => state.duration,
  isCallForConversation: state => conversationId => {
    return state.activeCall?.conversationId === conversationId;
  },
};

export const actions = {
  setActiveCall({ commit }, callData) {
    commit('SET_ACTIVE_CALL', callData);
  },

  clearActiveCall({ commit }) {
    commit('CLEAR_ACTIVE_CALL');
  },

  toggleMute({ commit, state }) {
    commit('SET_MUTED', !state.isMuted);
  },

  setConnected({ commit }, connected) {
    commit('SET_CONNECTED', connected);
  },

  updateDuration({ commit }, duration) {
    commit('SET_DURATION', duration);
  },

  updateStatus({ commit }, status) {
    commit('SET_STATUS', status);
  },

  setJanusSession({ commit }, session) {
    commit('SET_JANUS_SESSION', session);
  },

  setJanusPluginHandle({ commit }, handle) {
    commit('SET_JANUS_PLUGIN_HANDLE', handle);
  },

  async endCall({ commit, state }) {
    // Cleanup RTCPeerConnection
    if (state.janusPluginHandle) {
      // janusPluginHandle is actually an RTCPeerConnection, close it
      state.janusPluginHandle.close();
    }

    commit('CLEAR_ACTIVE_CALL');
  },
};

export const mutations = {
  SET_ACTIVE_CALL(state, callData) {
    state.activeCall = callData;
    state.duration = 0;
  },

  CLEAR_ACTIVE_CALL(state) {
    state.activeCall = null;
    state.isMuted = false;
    state.isConnected = false;
    state.duration = 0;
    state.janusSession = null;
    state.janusPluginHandle = null;
  },

  SET_MUTED(state, muted) {
    state.isMuted = muted;
  },

  SET_CONNECTED(state, connected) {
    state.isConnected = connected;
  },

  SET_DURATION(state, duration) {
    state.duration = duration;
  },

  SET_STATUS(state, status) {
    if (state.activeCall) {
      state.activeCall.status = status;
    }
  },

  SET_JANUS_SESSION(state, session) {
    state.janusSession = session;
  },

  SET_JANUS_PLUGIN_HANDLE(state, handle) {
    state.janusPluginHandle = handle;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
